module.exports = __webpack_public_path__ + "img/full2-min.cfbc47d0.png";